import React from 'react'
import ReactDOM from 'react-dom'
import { transitions, positions, Provider as AlertProvider } from 'react-alert'
import AlertTemplate from 'react-alert-template-basic'
import { ThemeProvider } from 'styled-components'
import { BrowserRouter } from 'react-router-dom'
import { Theme } from './presentation/styles/theme'
import Routes from './presentation/components/routes'
import { GlobalStyle } from './presentation/styles/global'

const options = {
  position: positions.BOTTOM_CENTER,
  timeout: 5000,
  offset: '30px',
  transition: transitions.SCALE,
}
ReactDOM.render(
  <ThemeProvider theme={Theme}>
    <React.StrictMode>
      <AlertProvider template={AlertTemplate} {...options}>
        <BrowserRouter>
          <GlobalStyle />
          <Routes />
        </BrowserRouter>
      </AlertProvider>
    </React.StrictMode>
  </ThemeProvider>,
  document.getElementById('root'),
)
